import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { FileIcon } from "@shopify/polaris-icons";
import { EDITOR_CONFIG } from "../../constants";
import JoditEditor from "jodit-react";
const Currency = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(false);
  const editor = useRef(null);
  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [item, setItem] = useState({
    currency: "",
  });

  const handleChangeCurrency = (newValue) => {
    setItem({ ...item, currency: newValue });
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    axios
      .get(`/settings/currencies`)
      .then((result) => {
        setItem({
          currency: result?.data?.data?.currency
            ? result.data.data.currency
            : "",
        });
        setIsSaving(false);
      })

      .catch((err) => console.log(err));
  }, []);
  return (
    <Page title={`Currency`} narrowWidth>
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <TextField
          value={item.currency}
          onChange={handleChangeCurrency}
          label="Currency"
        />
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/instructors/${id}`)
                  .then((result) => {
                    navigate("/admin/instructors");
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    setIsSaving(true);
    const form_data = new FormData();
    item.currency && form_data.append("currency", item.currency);
    form_data.append("_method", "PATCH");

    axios
      .post(`/settings/currencies`, form_data)
      .then((result) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch((err) => console.log(err));
  }
};

export default Currency;
